/**
 * Phase 39 — verdict SOURCES: which numbers a verdict card judges. Every
 * card reads TODAY'S DROPS added up by default (the drop bags, the 23 gate
 * metrics, DROP tags); a list-scoped card may read THE LIST'S OWN STATS
 * instead — the tracker's List report over a date range, the Flow metrics,
 * LIST tags — and the gateway card THE GATEWAY'S OWN STATS (the per-route
 * report, GATEWAY tags). The stop-loss judges a layer of many lists and
 * stays on drops. Missing = drops, so a saved container behaves as before.
 * For Media Devoted | Created By Ciro Autiero
 */

export const DROP_GEN_VERDICT_SOURCE_KINDS = [
  "drops",
  "list",
  "gateway",
] as const;
export type DropGenVerdictSourceKind =
  (typeof DROP_GEN_VERDICT_SOURCE_KINDS)[number];

/** The cards that carry a source; the scaling step's three trees share one. */
export const DROP_GEN_VERDICT_CARDS = [
  "listVerdict",
  "scaling",
  "gatewayVerdict",
  "hitAgain",
] as const;
export type DropGenVerdictCard = (typeof DROP_GEN_VERDICT_CARDS)[number];

export type DropGenVerdictSource =
  | { kind: "drops" }
  /** A tracker source reads one date range — a DROP_GEN_HOUR_DATE_RANGES preset, or `custom:<from>:<to>`. */
  | { kind: "list" | "gateway"; range: string };

export type DropGenVerdictSources = Partial<
  Record<DropGenVerdictCard, DropGenVerdictSource>
>;

export const DROPS_SOURCE: DropGenVerdictSource = { kind: "drops" };
export const DEFAULT_SOURCE_RANGE = "last-7-days";

/** The sample guard's metric per source: SMS settled on drops, unique visits on a tracker report. */
export type DropGenSourceSampleMetric = "smsSent" | "uniqueVisits";
